module.exports = __webpack_public_path__ + "assets/certificate_pdf/Microsys Solution Certified Specialist – BIG Data_320020.212be303.pdf";